import * as css from './SmsEditor.css';
import ModeBtn from '../../../component/modeBtn/ModeBtn';
import {useContext} from 'react';
import {BrandingContext} from '../BrandingPage';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import EditorWrapper from '../../../component/textEditor/editorWrapper/EditorWrapper';
import {updateEmailStatus} from '../../../redux/branding/brandingActions';
import {removeTagsFromText} from '../emailSubjectTextEditor/EmailSubjectTextEditor';
import {useBrandingParams} from '../../../hooks/useBrandingParams';
import {MESSAGE_TYPES} from '../menu/brandingConfig';

export const SMS_MAX_CHAR=1800;
export const SMS_CHARS_ON_MESSAGE=70;
export const SMS_FREE_CHARS=200;

function SmsEditor({name,onSave}) {
    const SMS_STATUS_FIELDS = {
        smsContent: 'smsTicket',
        smsEnterContent: 'smsEnter',
        smsRefContent: 'smsRefEnabled'
    };
    const {t} = useTranslation('branding');
    const {textEditor}= useContext(BrandingContext);
    const branding = useSelector(s => s.branding);
    const currentLang = branding.currentLang;
    const {messageType} = useBrandingParams();
    const smsValue = branding.data[currentLang]?.[messageType]?.[name];
    const smsStatus = messageType === MESSAGE_TYPES.desperate
        ? branding.data[currentLang]?.[messageType]?.enabledSms
        : branding.data[currentLang]?.[SMS_STATUS_FIELDS[name]];

    const dependencies=[currentLang,branding.getBrandingData[`${currentLang}XHR`]];

    const updateStatus = async () => {
        const field = messageType === MESSAGE_TYPES.desperate ? 'enabledSms' : SMS_STATUS_FIELDS[name];
        await updateEmailStatus(field, smsStatus===1?0:1, messageType);
    };
    
    const saveText = (text) =>{
        const textToSave = text.replace(/<\/p><p>/g, '\n');
        onSave(removeTagsFromText(textToSave));
    };

    const smsText = smsValue?.replace(/\n/g, '</p><p>');

    return (
        <>
            <css.top data-cy='smsEditor'>
                <css.text>{t(`${name}.${messageType}`)}</css.text>
                <ModeBtn className={'small'} status={smsStatus} click={updateStatus} dataCyName={'smsEditor'}/>
            </css.top>
            <EditorWrapper limit={{maxChar:SMS_MAX_CHAR,  showCharCounter:true,showMessagesAmount:true}} defaultText={!!smsText && `<p>${smsText}</p>`} showToolbar={false} dependencies={dependencies} events={{onSave: saveText,onFocus:()=>textEditor.setCurrentEditorName(name)}}   lang={currentLang}/>
        </>
    );
}

export default SmsEditor;